
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';

const { member } = api;

@Component({
  components: {},
})
export default class UserSignInLogList extends Vue {
  @Prop({ required: true }) private userId!: string;

  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private headers = [
    { text: '登入時間', value: 'createdOn', width: 150 },
    { text: 'Client Id', value: 'clientId', width: 150 },
    { text: '登入平台', value: 'platform' },
    { text: 'APP 版本', value: 'appVersion' },
  ];

  private filter = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    const { data } = await member.listSignInLogs(this.userId, this.filter);
    this.data = data;
  }

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: UserSignInLogList) => void) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
